export default "__VITE_ASSET__C0MBuW2V__"